import { createFileRoute } from "@tanstack/react-router";

import { parseSentSearch } from "@/features/growth";
import { SentMessagesPage } from "@/features/growth/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/growth/messages/people/$userId")({
  validateSearch: strictSearch(parseSentSearch),
  component: SentMessages,
});

function SentMessages() {
  const { userId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SentMessagesPage
      key={userId}
      userId={userId}
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
    />
  );
}
